import { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { productApi } from '../../api/products';

export function ProductEditorPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isNew = !id;
  const [name, setName] = useState('');
  const [sku, setSku] = useState('');
  const [brand, setBrand] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const payload = { name, brand, description, identity: { sku }, type: 'physical' as const };
      const p = isNew ? await productApi.create(payload) : await productApi.update(id!, payload);
      void navigate(`/products/${p.id}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Save failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="mx-auto max-w-2xl p-6">
      <Link to={isNew ? '/products' : `/products/${id}`} className="text-sm text-slate-600 hover:underline">← Back</Link>
      <h1 className="mt-4 text-2xl font-semibold">{isNew ? 'Create Product' : 'Edit Product'}</h1>
      <form onSubmit={(e) => void submit(e)} className="mt-6 space-y-4">
        <input required value={name} onChange={(e) => setName(e.target.value)} placeholder="Product name" className="w-full rounded-lg border px-3 py-2" />
        <input value={sku} onChange={(e) => setSku(e.target.value)} placeholder="SKU" className="w-full rounded-lg border px-3 py-2" />
        <input value={brand} onChange={(e) => setBrand(e.target.value)} placeholder="Brand" className="w-full rounded-lg border px-3 py-2" />
        <textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Description" className="w-full rounded-lg border px-3 py-2" rows={4} />
        {error && <p className="text-sm text-red-600">{error}</p>}
        <button type="submit" disabled={loading} className="rounded-lg bg-slate-900 px-4 py-2 text-sm text-white disabled:opacity-50">{loading ? 'Saving…' : 'Save'}</button>
      </form>
    </div>
  );
}
